import { render, staticRenderFns } from "./facilityInfoDetail.vue?vue&type=template&id=22c649fe&scoped=true"
import script from "./facilityInfoDetail.vue?vue&type=script&lang=js"
export * from "./facilityInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./facilityInfoDetail.vue?vue&type=style&index=0&id=22c649fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c649fe",
  null
  
)

export default component.exports